<template lang="pug">
  .amazon-pay
    .edit(v-if="validAmazonSession")
      AmazonPayWidget
      ThirdPartyProfileDefaults(:done-method="onCancel")

    .init(v-else)
      p.mb-15 To edit your Amazon billing info:
      AmazonPayButton

</template>

<script>
  import { mapState, mapGetters } from 'vuex';
  import AmazonPayButton from "./AmazonPayButton";
  import AmazonPayWidget from "./AmazonPayWidget";
  import ThirdPartyProfileDefaults from "./ThirdPartyProfileDefaults";

  export default {
    name: "AmazonPay",
    components: {
      ThirdPartyProfileDefaults,
      AmazonPayButton,
      AmazonPayWidget
    },

    props: {
      doneMethod: {
        type: Function,
        required: true
      }
    },

    computed: {
      ...mapState('payments', [
        'savingProfile',
        'editProfileForm',
        'validAmazonSession'
      ]),

      ...mapGetters('subscriptions', [
        'activeSubscriptionIds'
      ]),

      amazonIsDirty() {
        return this.initialAmazonIsDefault != this.is_default || this.initialAmazonUseOnAllSubs != this.use_payment_for_all_subscriptions;
      },

      is_default: {
        get() {
          return this.editProfileForm.is_default;
        },

        set(value) {
          this.updateIsDefault(value);
        }
      },

      use_payment_for_all_subscriptions: {
        get() {
          return this.editProfileForm.use_payment_for_all_subscriptions;
        },

        set(value) {
          this.updateUseProfileForAllSubs(value);
        }
      }
    }
  }
</script>

<style scoped lang="stylus">


</style>